import { Component, Output, EventEmitter} from '@angular/core';

@Component({
  selector: 'toggle-button',
  template: `
    <input type="checkbox" id="toggle-button-checkbox"
      (change)="changed.emit($event.target.checked)">
    <label class="toggle-button-switch"  
      for="toggle-button-checkbox"></label>
    <div class="toggle-button-text">
      <div class="toggle-button-text-on">Sum</div>
      <div class="toggle-button-text-off">Avg</div>
    </div>
  `,
  styles: [`
    :host {
      display: block;
      position: relative;
      width: 100px;
      height: 50px;
    }
    
    input[type="checkbox"] {
      display: none; 
    }

    /* 토글 버튼 내부의 원. 감춘 체크박스와 연동한다. */
    .toggle-button-switch {
      position: absolute;
      top: 0px;
      left: 0px;
      width: 37px;
      height: 37px;
      background-color: #fff;
      border-radius: 100%;
      cursor: pointer;
      z-index: 100;
      transition: left 0.3s;
    }

    /* 토글 버튼의 바탕 */
    .toggle-button-text {
      overflow: hidden;
      background-color: #0f0fd1;
      border-radius: 25px;
      box-shadow: 2px 2px 5px 0 rgba(50, 50, 50, 0.75);
      transition: background-color 0.3s;
    }

    /* 토글 버튼의 텍스트 */
    .toggle-button-text-on,
    .toggle-button-text-off {
      float: left;
      width: 45%;
      height: 100%;
      line-height: 35px;
      font-family: Lato, sans-serif;
      font-weight: bold;
      color: #fff;
      text-align: center;
    }

    /* 체크박스가 체크 상태이면 토글 버튼 내부의 원을 오른쪽으로 52px 이동 */
    input[type="checkbox"]:checked ~ .toggle-button-switch {
      left: 52px;
    }

    /* 체크박스가 체크 상태이면 토글 버튼의 배경색 변경 */
    input[type="checkbox"]:checked ~ .toggle-button-text {
      background-color: #3dbf87;
    }
  `]
})
export class ToggleButtonComponent  {
  @Output() changed = new EventEmitter<boolean>();
}
